import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import "./CatalogIndex.css";

export interface BatchAction {
  icon: IconDefinition;
  label: string;
  onClick: () => void;
  variant?: "default" | "danger";
}

export interface BatchActionPillProps {
  selectedCount: number;
  actions: BatchAction[];
}

export const BatchActionPill = ({
  selectedCount,
  actions,
}: BatchActionPillProps) => {
  if (selectedCount <= 0) return null;
  return (
    <div className="batchActionPill" role="group" aria-label="Batch actions">
      <span className="batchActionPill__count">{selectedCount} Selected</span>
      {actions.map((action, idx) => (
        <span
          key={`${action.label}-${idx}`}
          style={{ display: "inline-flex", alignItems: "center" }}
        >
          <span className="batchActionPill__divider" aria-hidden="true" />
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`batch-${idx}`}>{action.label}</Tooltip>}
          >
            <button
              type="button"
              aria-label={action.label}
              onClick={action.onClick}
              className={
                action.variant === "danger"
                  ? "batchActionPill__action batchActionPill__action--danger"
                  : "batchActionPill__action"
              }
            >
              <FontAwesomeIcon icon={action.icon} />
            </button>
          </OverlayTrigger>
        </span>
      ))}
    </div>
  );
};
